import { client } from '@/generated/api-client/client.gen'
import { installUnauthorizedLogoutInterceptor } from '@/lib/api/client/unauthorized-logout.interceptor'

let configured = false

/** Configure the hey-api OpenAPI client once for browser requests. */
export function configureOpenApiClient() {
    if (configured) return
    client.setConfig({
        baseURL: process.env.NEXT_PUBLIC_API_URL ?? '/api',
    })
    installUnauthorizedLogoutInterceptor(client.instance)
    configured = true
}
